import { render, staticRenderFns } from "./Autograph.vue?vue&type=template&id=53098a36&scoped=true&"
import script from "./Autograph.vue?vue&type=script&lang=js&"
export * from "./Autograph.vue?vue&type=script&lang=js&"
import style0 from "./Autograph.vue?vue&type=style&index=0&id=53098a36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53098a36",
  null
  
)

export default component.exports